module.exports = __webpack_public_path__ + "static/media/logo.4c6371c8.svg";